// AppRoutes.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import service_info from './Sections/ServiceInfo.js';
import SubCategoryPage from './SubCategoryPage';
import App from "./App";

function AppRoutes({ children }) {
    // Object.values(service_info).map((category) =>
    //     category.content.map((subCategory) => (
    //         // console.log(`/${category.path}-${subCategory.path}`)
    //     )))
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path={`/`}
                    element={
                        children
                    }
                />
                {Object.values(service_info).map((category) =>

                    category.content.map((subCategory) => (

                        <Route
                            key={`${category.path}-${subCategory.path}`}
                            path={`/${category.path}/${subCategory.path}`}
                            element={
                                <SubCategoryPage
                                    category={category}
                                    subCategory={subCategory}
                                />
                            }
                        />
                    ))
                )}
            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;
